import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api-client';
import { useAuthStore } from '../store/auth';

export const transcriptKeys = {
  all: ['academic-transcripts'] as const,
  list: (params: Record<string, unknown>) => [...transcriptKeys.all, params] as const,
};

export function useTranscripts(params?: { programId?: string }) {
  const { user } = useAuthStore();
  return useQuery({
    queryKey: transcriptKeys.list({ ...params, userId: user?.id }),
    queryFn: () =>
      apiClient.academicTranscripts.list({
        userId: user?.id,
        ...params,
      }),
    enabled: !!user?.id,
  });
}

export function useProgramTranscript(programId?: string, userId?: string) {
  const { user } = useAuthStore();
  const targetUserId = userId || user?.id;

  return useQuery({
    queryKey: ['program-transcript', programId, targetUserId],
    queryFn: () =>
      apiClient.academicTranscripts.getProgramTranscript(programId!, {
        userId: targetUserId,
      }),
    enabled: !!programId && !!targetUserId,
  });
}

export function useStudentProgressReport(programId?: string, userId?: string) {
  const { user } = useAuthStore();
  const targetUserId = userId || user?.id;

  return useQuery({
    queryKey: ['student-progress-report', programId, targetUserId],
    queryFn: () =>
      apiClient.academicTranscripts.getProgressReport(programId!, {
        userId: targetUserId,
      }),
    enabled: !!programId && !!targetUserId,
  });
}

export function useLegacyTranscripts(userId?: string, enabled = true) {
  const { user } = useAuthStore();
  const targetUserId = userId || user?.id;

  return useQuery({
    queryKey: ['legacy-academic-transcripts', targetUserId],
    queryFn: () =>
      apiClient.academicTranscripts.getLegacy({
        userId: targetUserId,
      }),
    enabled: Boolean(targetUserId) && enabled,
  });
}
